import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ToastProvider } from './components/ToastContext';
import { VaultProvider } from './components/VaultContext';
import ToastContainer from './components/ToastContainer';
import RequireAuth from './auth/RequireAuth';
import Require2FA from './auth/Require2FA';
import RequireTerms from './auth/RequireTerms';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import TwoFactorLoginPage from './pages/TwoFactorLoginPage';
import Setup2FAPage from './pages/Setup2FAPage';
import DashboardPage from './pages/DashboardPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import AcceptForeverFreePage from './pages/AcceptForeverFreePage';
import AdminPage from './pages/AdminPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import PrintVaultPage from './pages/PrintVaultPage';
import PrintHeirloomsPage from './pages/PrintHeirloomsPage';
import HelpPage from './pages/HelpPage';
import CloseAccountPage from './pages/CloseAccountPage';
import ReAcceptTermsPage from './pages/ReAcceptTermsPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <VaultProvider>
        <ToastProvider>
        <ToastContainer />
        <div className="App">
          <ScrollToTop />
          <AnalyticsTracker />
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/confirm-email" element={<ConfirmEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/2fa-login" element={<TwoFactorLoginPage />} />
            <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />
            <Route path="/accept-free-vault/:token" element={<AcceptForeverFreePage />} />
            <Route path="/help" element={<HelpPage />} />

            {/* Authenticated but no 2FA required */}
            <Route element={<RequireAuth />}>
              <Route path="/setup-2fa" element={<Setup2FAPage />} />

              {/* Authenticated + 2FA required */}
              <Route element={<Require2FA />}>
                {/* Re-acceptance page is reachable before T&C gate */}
                <Route path="/re-accept-terms" element={<ReAcceptTermsPage />} />

                {/* T&C gate — blocks access if user hasn't accepted current T&Cs */}
                <Route element={<RequireTerms />}>
                  <Route element={<Layout />}>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/change-password" element={<ChangePasswordPage />} />
                    <Route path="/vault/:id/print" element={<PrintVaultPage />} />
                    <Route path="/vault/:id/print/heirlooms" element={<PrintHeirloomsPage />} />
                  </Route>
                  {/* Focused pages without navigation shell */}
                  <Route path="/vault/:vaultId/close" element={<CloseAccountPage />} />
                </Route>
              </Route>
            </Route>

            {/* Catch-all */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        </ToastProvider>
        </VaultProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
